import { Outlet } from "react-router-dom";

export default function PatronGuard() {
    return <Outlet />;
}